<script setup lang="ts">
    import { DOCUMENT_EDIT_LOCK_TITLES, type DocumentEditLockReason } from '~/composables/invoicing/useDocumentEditLock';

    const form = useForm<{}>({});

    // The title names why this document is read-only. Opened without a reason it keeps
    // the one it always had, the progress-billing lock on a quote.
    const reason = ref<DocumentEditLockReason>('progress_billing');
    const title = computed(() => DOCUMENT_EDIT_LOCK_TITLES[reason.value]);

    useModal('invoicing:invoice-form:edit-disable', (payload?: { reason?: DocumentEditLockReason }) => {
        reason.value = payload?.reason ?? 'progress_billing';
    });

    const confirm = () => {
        useEvent('invoicing:invoice-form:edit-disable:close');
    };
</script>

<template>
    <Modal
        ref="modal"
        name="invoicing:invoice-form:edit-disable"
    >
        <div :class="$theme('modal.title.container')">
            <h2 :class="$theme('modal.title.text', 'px-12')">
                {{ $t(title) }}
            </h2>
        </div>
        <div :class="$theme('modal.padding')">
            <div class="flex justify-center mb-8">
                <div class="max-w-[180px] h-[180px]">
                    <Lottie json="https://shared-assets.trustup.io/lottie/warning.json" />
                </div>
            </div>

            <div :class="$theme('modal.footer.button_container')">
                <LoadingButton
                    :extra-class-name="$theme('modal.footer.button')"
                    :class-name="$theme('button.style.cancel')"
                    prevent-default
                    @clicked="useEvent('invoicing:invoice-form:edit-disable:close')"
                >
                    {{ $t('actions.cancel') }}
                </LoadingButton>
                <LoadingButton
                    :extra-class-name="$theme('modal.footer.button')"
                    :class-name="$theme('button.style.default')"
                    :loading="form.isLoading"
                    @clicked="confirm"
                >
                    {{ $t('actions.understood') }}
                </LoadingButton>
            </div>
        </div>
    </Modal>
</template>
